import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "text-base leading-6 font-medium text-black flex gap-x-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { id: "searchOverlayTarget" }
const _hoisted_5 = { class: "flex flex-col max-h-64 overflow-auto w-full top-36" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = {
  key: 0,
  class: "py-6 border-0 px-4"
}
const _hoisted_8 = { class: "ml-3 min-w-[32px] min-h-[32px] rounded-full items-center justify-center flex" }
const _hoisted_9 = {
  key: 0,
  class: "flex justify-between items-center px-3 bg-white h-[54px] w-full rounded-b-md border-t border-gray-200"
}
const _hoisted_10 = { class: "flex items-center gap-x-4" }
const _hoisted_11 = { class: "text-base leading-6 font-medium w-fit" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col pt-3"
}
const _hoisted_13 = { class: "min-w-[32px] min-h-[32px] rounded-full items-center justify-center flex" }

import { computed, onMounted, ref, watch } from "vue"
import { MinusSmIcon, SearchIcon, TrashIcon } from "@heroicons/vue/outline"
import GgmsLoading from "@/components/GgmsLoading.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsButton from "@/components/GgmsButton.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import { useWorkflowStore } from "@/stores/workflow"
import { Workflow } from "@/shared/models/workflow"
import { debounce } from "@/shared/utils/helpers"


export default /*#__PURE__*/_defineComponent({
  __name: 'EnrollAndUnenrollSidebar',
  setup(__props) {

const workflowStore = useWorkflowStore()

const searchMenu = ref()
const search = ref("")
const isSearching = ref(false)
const isAllSelected = ref(false)
const total = ref(0)
const showData = ref(false)

const selectedWorkflows = ref<Workflow[]>([])
const data = ref<Workflow[]>([])

const selectAllText = computed(() => (isAllSelected.value ? "Deselect all" : `Select all (${total.value})`))

function toggleSearchMenu(event?: Event) {
    searchMenu.value.show(event)
}

function clearData() {
    workflowStore.selectedData = []
}

function onSelect() {
    if (isAllSelected.value) {
        clearData()
    } else {
        workflowStore.selectedData = selectedWorkflows.value
    }
    isAllSelected.value = !isAllSelected.value
}

function closeSearchMenu() {
    showData.value = true
    searchMenu.value.hide()
}

function isElementChecked(element: Workflow) {
    return !!workflowStore.selectedData.find((el) => el._id === element._id)
}

function onClick(element: Workflow) {
    if (isElementChecked(element)) {
        const index = workflowStore.selectedData.findIndex((el) => el._id === element._id)
        workflowStore.selectedData.splice(index, 1)
        return
    }

    workflowStore.selectedData.push(element)
}

function deleteData(element: Workflow) {
    workflowStore.selectedData.splice(workflowStore.selectedData.indexOf(element), 1)
}

watch(
    () => search.value,
    debounce(async () => {
        if (workflowStore.workflow._id) {
            selectedWorkflows.value = await workflowStore.autocomplete(search.value, workflowStore.workflow._id)
        } else {
            selectedWorkflows.value = await workflowStore.autocomplete(search.value)
        }
    }, 250)
)

watch(
    () => workflowStore.selectedData,
    () => {
        workflowStore.areButtonDisabled = !workflowStore.selectedData.length
    },
    { deep: true }
)

onMounted(async () => {
    if (workflowStore.workflow._id) {
        selectedWorkflows.value = await workflowStore.autocomplete(search.value, workflowStore.workflow._id)
    } else {
        selectedWorkflows.value = await workflowStore.autocomplete(search.value)
    }
    if (workflowStore.selectedData.length) {
        showData.value = true
    }

    total.value = selectedWorkflows.value.length
})

return (_ctx: any,_cache: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(workflowStore).isEnrollWorkflow)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Enrolled in"))
        : (_openBlock(), _createElementBlock("p", _hoisted_3, "Unenrolled from")),
      _createTextVNode(" one of the workflows: ")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(GgmsInput, {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        class: "w-full mt-4",
        iconStart: _unref(SearchIcon),
        placeholder: "Search",
        onInput: toggleSearchMenu,
        onClick: toggleSearchMenu
      }, null, 8, ["modelValue", "iconStart"]),
      _createVNode(_component_OverlayPanel, {
        ref_key: "searchMenu",
        ref: searchMenu,
        class: "!left-0 ring-1 ring-black ring-opacity-5 shadow-lg rounded-md bg-white mx-6 right-1",
        appendTo: "#searchOverlayTarget"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (!selectedWorkflows.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "No results found"))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(selectedWorkflows.value, (workflow) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: workflow._id,
                      class: "flex items-center gap-x-2 px-4 py-3 cursor-pointer border-b border-gray-200 last:border-0",
                      tabindex: "0"
                    }, [
                      _createVNode(GgmsCheckBox, {
                        checked: isElementChecked(workflow),
                        onClick: ($event: any) => (onClick(workflow))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(workflow?.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["checked", "onClick"])
                    ]))
                  }), 128)),
              (isSearching.value)
                ? (_openBlock(), _createBlock(GgmsLoading, { key: 2 }))
                : _createCommentVNode("", true)
            ])
          ]),
          (_unref(workflowStore).selectedData.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: "bg-gray-300 w-4 h-4 rounded-sm cursor-pointer",
                    onClick: clearData
                  }, [
                    _createVNode(_unref(MinusSmIcon), { class: "w-4 h-4" })
                  ]),
                  _createElementVNode("p", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_unref(workflowStore).selectedData.length) + " selected - ", 1),
                    _createElementVNode("span", {
                      class: "font-medium text-primary-color-600 hover:text-primary-color-500 cursor-pointer",
                      onClick: onSelect
                    }, _toDisplayString(selectAllText.value), 1)
                  ])
                ]),
                _createVNode(GgmsButton, { onClick: closeSearchMenu }, {
                  default: _withCtx(() => [
                    _createTextVNode("Done")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512),
      (showData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workflowStore).selectedData, (workflow) => {
              return (_openBlock(), _createElementBlock("div", {
                key: workflow._id,
                class: "flex justify-between items-center border-b border-gray-200 last:border-0 py-2.5 px-2"
              }, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(workflow?.name), 1),
                _createVNode(_unref(TrashIcon), {
                  class: "x-5 h-5 m-1 cursor-pointer",
                  onClick: ($event: any) => (deleteData(workflow))
                }, null, 8, ["onClick"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})